module.exports = __webpack_public_path__ + "img/trello.8370d86a.svg";